import React from "react";
import PropTypes from "prop-types";

function ErrorComponent(props) {
  switch (props.error.message) {
    case "404":
      console.log(" ->", "Just did a 404 in my pants");
      //Redirect to uvm.edu 404 page
      window.location.replace(
        "https://www.uvm.edu/search/google/" +
          window.location.pathname.replace(/^\/+|\/+$/g, "").replace(/\//g, " ")
      );
      break;
    case "301":
      window.location.href = props.data.path;
      break;
    default:
      return (
        <section className="content">
          <h1 className="error">
            {props.error.message}
          </h1>
        </section>
      );
  }
}

ErrorComponent.propTypes = {
  error: PropTypes.object.isRequired
};

export default ErrorComponent;
